export class RichError extends Error {
  metadata: Record<string, unknown>;

  constructor(message: string, metadata: Record<string, unknown>) {
    super(message);
    this.name = 'RichError';
    this.metadata = metadata;
  }
}
